import useFlippableCard from './useFlippableCard.hook';
import { StyledFlippableCard } from './FlippableCard.styled';
import Sprite from '@/shared/GameComponents/GameObjects/Sprite/Sprite';
import SimpleImage from '@/shared/GameComponents/GameObjects/SimpleImage/SimpleImage';
import { useRef } from 'react';
import { StyledGameObject } from '@/shared/GameComponents/GameObjects/GameObject.styled';
import useTransform from '@/shared/GameComponents/GameObjects/SimpleImage/useTransfrom.hook';
import ResponsiveText from '@/shared/ResponsiveText/ResponsiveText';

const cardSize = { width: 233, height: 312 };

export default function FlippableCard({
  concept,
  onCardClick,
  disabled,
  isLastCorrect,
}) {
  const containerRef = useRef();
  const textRef = useRef();
  const { state, actions } = useFlippableCard({ concept, containerRef });

  const { responsiveTransform, originalSize } = useTransform({
    transform: concept.transform,
    pixelSize: cardSize,
  });

  const flipVariants = {
    flipping: {
      rotateY: 180,
      transition: {
        duration: 0.5,
      },
    },
    unflipping: {
      rotateY: 0,
      transition: {
        duration: 0.5,
      },
    },
  };
  return (
    <>
      {responsiveTransform && originalSize && (
        <StyledGameObject
          ref={containerRef}
          responsiveTransform={responsiveTransform}
          originalSize={originalSize}
          onClick={() => onCardClick(concept)}
          active={!concept.flipped && !disabled}
        >
          <StyledFlippableCard
            onUpdate={actions.onFlipUpdate}
            variants={flipVariants}
            animate={concept.flipped ? 'flipping' : 'unflipping'}
            className={isLastCorrect ? 'last-correct' : ''}
          >
            {state.showFront ? (
              <div className="card-front">
                <SimpleImage
                  imageId="cardFrontBg"
                  transform={innerCommonTransform}
                  relativeTo={containerRef}
                  pixelSize={cardSize}
                />
                <Sprite
                  spriteId={concept.id}
                  transform={innerFrontCommonTransform}
                  relativeTo={containerRef}
                />
                <div className="card-front-text">
                  <div className="card-front-text-inner" ref={textRef}>
                    <ResponsiveText parentRef={textRef}>
                      {concept.txt}
                    </ResponsiveText>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {disabled ? <div className="disabled-overlay"></div> : null}
                <div className="card-back">
                  <SimpleImage
                    imageId="cardBackBg"
                    transform={innerCommonTransform}
                    relativeTo={containerRef}
                    pixelSize={cardSize}
                  />
                </div>
              </>
            )}
          </StyledFlippableCard>
        </StyledGameObject>
      )}
    </>
  );
}

const innerCommonTransform = {
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  pivot: { x: 0, y: 0 },
};
const innerFrontCommonTransform = {
  x: 100,
  y: 0,
  width: -100,
  height: 100,
  pivot: { x: 0, y: 0 },
};
